import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { AE_ICON_SIZE } from '@/components/assessment-engine/layout/aeTheme';
import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

interface BuilderDragHandleProps {
  label: string;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  disabled?: boolean;
}

/** Grip handle for drag-and-drop reorder in the template builder. */
export const BuilderDragHandle: React.FC<BuilderDragHandleProps> = ({
  label,
  listeners,
  attributes,
  disabled,
}) => {
  if (disabled) return null;

  return (
    <button
      type="button"
      className="shrink-0 cursor-grab touch-none rounded p-0.5 text-[var(--color-secondary-text)] hover:text-[var(--color-primary-text)] active:cursor-grabbing"
      aria-label={label}
      {...attributes}
      {...listeners}
    >
      <Bars3Icon className={AE_ICON_SIZE} aria-hidden />
    </button>
  );
};
